export const apiKeyAsterisks = (apiKey) => {
    if (!apiKey) return '';
    return "*".repeat(apiKey.length - 4) + apiKey.slice(-4);
}